<!-- eslint-disable -->
<template lang="pug">
    .settings(v-if='settings')
        span
            | {{ $i18n.t('trainer.trainer_gameFormSetting_mode') }}:
            | {{ $i18n.t('trainer.trainer_gameFormSetting_' + settings.mode) }}
        br
        span
            | {{ $i18n.t('trainer.trainer_gameFormSetting_numOfExamples') }}:
            | {{ settings.numOfExamples }}
        br
        span
            | {{ $i18n.t('trainer.trainer_gameFormSetting_difficulty') }}:
            | {{ settings.difficult.name }}
        br
        span
            | {{ $i18n.t('trainer.trainer_gameFormSetting_startDistance') }}:
            | {{ settings.startDistance }}
        br
        span
            | {{ $i18n.t('trainer.trainer_gameFormSetting_distanceIncrease') }}:
            | {{ settings.distanceIncrease }}
        br
        span
            | {{ $i18n.t('trainer.trainer_gameFormSetting_visionFieldSpeed') }}:
            | {{ settings.speed }} {{ $i18n.t('trainer.trainer_gameFormSettingValue_seconds') }}
        br
        slot
</template>

<script>
    /*eslint-disable*/
    import TrainerUtilities from '../../../utils/trainer/trainer';
    import gamePreviewMixin from "../../../utils/trainer/gamePreviewMixin";

    export default {
        mixins: [TrainerUtilities, gamePreviewMixin],
        props: {
            game: Object,
            parameters: Object,
            userId: Number,
            parametersFrom: {
                type: String,
                default: 'homework'
            },
            withIcon: Boolean
        }
    }
</script>
